import React from 'react';
import './Testimonial.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import imgOne from '../../assets/courses/testimonial-1.jpg';
import imgTwo from '../../assets/courses/testimonial-2.jpg';
import Slider from "react-slick";

const img = [
   imgOne,
   imgTwo,
  ];
  
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };
  
  const Testimonial = () => {
    return (
      <section className='testimonail-section section-bg section-common pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
        <div className="container">
          <div className="row align-items-end mb-4">
            <div className="col-lg-12">
              <SectionTitle 
                subTitle="Ellos ya lo vivieron"
                title="Mirá lo que dicen quienes confiaron en mí"
              />
               <p className="text-muted">
                Me llena de orgullo recibir estos mensajes. Gracias por ser parte de esta experiencia ✨
              </p>
            </div>
          </div>
  
          <Slider {...sliderSettings} className="testimoni-slider">
            {img.map((img, index) => (
              <div key={index} className="px-3 testimonial-img">
                <img 
                  src={img} 
                  alt="Testimonial"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '400px', height: '250px' }}
                />
              </div>
            ))}
          </Slider>
        </div>
      </section>
    );
  };

export default Testimonial;